import NewInvestmentTaxRegime from './newInvestmentTaxRegime';
export default NewInvestmentTaxRegime;